export const DefaultOGImage = 'stores/ooka_default/ooka_og.jpg'
